import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21 18V12C21 10.3 19.7 9 18 9H12C10.3 9 9 10.3 9 12V18C9 19.7 10.3 21 12 21H18C19.7 21 21 19.7 21 18ZM12 19C11.4 19 11 18.6 11 18V12C11 11.4 11.4 11 12 11H18C18.6 11 19 11.4 19 12V18C19 18.6 18.6 19 18 19H12Z",
			fill: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 13.5H17",
			stroke: "var(--main-color)",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 16.5H17",
			stroke: "var(--main-color)",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 15H5.7C4.2 15 3 13.8 3 12.3V5.7C3 4.2 4.2 3 5.7 3L12.4 3C13.8 3 15 4.2 15 5.7V8H13V5.7C13 5.3 12.7 5 12.3 5H5.6C5.3 5 5 5.3 5 5.7V12.4C5 12.8 5.3 13.1 5.7 13.1H8V15Z",
			fill: "var(--main-color)"
		})
	]
});
export { SvgCopy as ReactComponent };
